/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsCheckFieldsMap model module.
 * @module model/EmailsCheckFieldsMap
 * @version 1.0.0
 */
export class EmailsCheckFieldsMap {
  /**
   * Constructs a new <code>EmailsCheckFieldsMap</code>.
   * @alias module:model/EmailsCheckFieldsMap
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsCheckFieldsMap</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsCheckFieldsMap} obj Optional instance to populate.
   * @return {module:model/EmailsCheckFieldsMap} The populated <code>EmailsCheckFieldsMap</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsCheckFieldsMap();
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} email
 */
EmailsCheckFieldsMap.prototype.email = undefined;

